import { useState, Fragment, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import AddRoundedIcon from "@material-ui/icons/AddRounded";

import { ModalZeroResults } from "../../shared/components/UIElements/ModalZeroResults";
import { ButtonLoadMore } from "../../shared/components/UIElements/ButtonLoadMore";
import { SaleDashFinacingItemMarketplace } from "./SaleDashFinacingItemMarketplace";
import { PopoverAddBTGFinancing } from "./PopoverAddBTGFinancing";
import { PopoverAddBTGRegistrationRequest } from "./PopoverAddBTGRegistrationRequest";
import { FinancingBTGWarning } from "./FinancingBTGWarning";
import { ModalError } from "../../shared/components/UIElements/ModalError";
import { useHttpClient } from "../../shared/hooks/httpHook";
import { getPastDaysFromDate } from "../../shared/util/getDaysFromDate";
import {
  getCustomerFinancings,
  checkIfIntegratorCanReqBTGFin,
  getUserRegistration,
  getProposalFinancings,
} from "../api/financingsAPI";
import {
  AuthContextProps,
  CustomerDataPopEst,
  FinancingData,
  CustomerData,
  SettingsContextProps,
  RegistrationData,
  ProposalData,
  ExpiredFinsData,
} from "../../shared/data/types";

import "./SaleDash.scss";

interface SaleDashFinancingsMarketplaceProps {
  settingsCtx: SettingsContextProps;
  auth: AuthContextProps;
  customerId: string;
  customer: CustomerDataPopEst | CustomerData;
  proposal?: ProposalData;
  type?:
    | "SALES"
    | "PROJECT"
    | "INSTALLATION"
    | "AFTER_SALES"
    | "PRE_SALES"
    | "ADMINISTRATIVE";
}

export const SaleDashFinancingsMarketplace = (
  props: SaleDashFinancingsMarketplaceProps
) => {
  const { settingsCtx, auth, customerId, customer, type, proposal } = props;
  const {
    error,
    sendRequest,
    clearError,
    isLoading,
    zeroResults,
    clearZeroResults,
  } = useHttpClient();
  const [loadedFinancings, setLoadedFinancings] =
    useState<FinancingData[]>(null);
  const [expiredFinData, setExpiredFinData] = useState<ExpiredFinsData>(null);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [multiplier, setMultiplier] = useState<number>(0);
  const [showLoadMore, setShowLoadMore] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null);

  useEffect(() => {
    setLoadedFinancings(null);
    setMultiplier(0);
    setShowLoadMore(false);

    if (!!customerId && !proposal) {
      getCustomerFinancings({
        customerId,
        sendRequest,
        auth,
        hidration: true,
        setLoadedFinancings,
        setShowLoadMore,
        multiplier: 0,
        setFirstLoad,
        setExpiredFinData,
      });
    } else if (!!customerId && !!proposal) {
      getProposalFinancings({
        proposalId: proposal?._id,
        sendRequest,
        auth,
        hidration: true,
        setLoadedFinancings,
        setShowLoadMore,
        multiplier: 0,
        setFirstLoad,
        setExpiredFinData,
      });
    }
  }, [customerId, proposal]);

  const getCustomerFinancingsHandler = async (mult: number) => {
    if (!!customerId && !proposal) {
      await getCustomerFinancings({
        customerId,
        sendRequest,
        auth,
        hidration: false,
        setLoadedFinancings,
        setShowLoadMore,
        multiplier: mult,
        setExpiredFinData,
      });
    } else if (!!customerId && !!proposal) {
      await getProposalFinancings({
        proposalId: proposal?._id,
        sendRequest,
        auth,
        hidration: false,
        setLoadedFinancings,
        setShowLoadMore,
        multiplier: mult,
        setExpiredFinData,
      });
    }
  };

  return (
    <Fragment>
      <ModalZeroResults
        show={zeroResults}
        closePopupHandler={clearZeroResults}
      />
      <PopoverAddBTGFinancing
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        auth={auth}
        cid={customer?._id || ""}
        customer={customer}
        setLoadedFinancings={setLoadedFinancings}
        proposal={proposal}
        customerProposals={
          !proposal
            ? ((customer?.proposals || []) as ProposalData[])
            : [proposal]
        }
      />
      <ModalError error={error} onClear={clearError} />
      {!loadedFinancings && (
        <div className="sale-dash__col-right-content-spinner">
          <CircularProgress color="primary" />
        </div>
      )}
      {loadedFinancings && loadedFinancings?.length === 0 && (
        <p className="sale-dash__col-right-content-empty">
          {!!customerId && !!proposal
            ? "Esta proposta não possui financiamentos"
            : "Este clientes não possui financiamentos"}
        </p>
      )}
      <div className="sale-dash__proposals">
        {loadedFinancings?.length > 0 &&
          loadedFinancings?.map((item, i) => {
            return (
              <SaleDashFinacingItemMarketplace
                auth={auth}
                customerId={customerId}
                setLoadedFinancings={setLoadedFinancings}
                loadedFinancing={item}
                key={`financing-${i}`}
              />
            );
          })}
        {!isLoading && <div className="sale-dash__add-btn-fixed"></div>}
      </div>
      {/* {loadedFinancings && loadedFinancings?.length === 0 && ( */}
      <div className="sale-dash__col-right-add-item-btn">
        {!isLoading && loadedFinancings && (
          <IconButton
            title="Solicitar novo financiamento"
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            <AddRoundedIcon />
          </IconButton>
        )}
        {loadedFinancings && isLoading && <CircularProgress color="primary" />}
      </div>
      {/* )} */}
      <div className="sale-dash__col-right-content-load-more">
        <ButtonLoadMore
          setMultiplier={setMultiplier}
          showLoadMore={showLoadMore}
          isLoading={isLoading}
          fetchItems={getCustomerFinancingsHandler}
          noMargin
        />
      </div>
    </Fragment>
  );
};
